import { isValidPhoneNumber } from "libphonenumber-js"

export function isValidPhone(value: string | undefined | null): boolean {
  if (!value) return true
  return isValidPhoneNumber(value)
}

export function normalizePhoneExtension(value: string): string {
  return value.replace(/\D/g, "")
}
